type errorMessageType = {
  [key: string]: string;
};

const errorMessages: errorMessageType = {
  noResponse: 'The server is not responding!',
  unexpectedError: 'Unexpected error occurred!',
};

export const handleError = (error: any, callback: Function) => {
  if (error.response) {
    callback(errorMessages.unexpectedError, error.response?.data?.message);
  } else if (error.request) {
    callback(errorMessages.noResponse);
  } else {
    callback(errorMessages.unexpectedError);
  }
};
